module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-autoplay-selected@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-autoplay-selected@1x.png
// module id = 611
// module chunks = 0